import ScrollToTopButton from 'components/atoms/scroll-to-top-button';
import CareManagersFilter from 'components/organisms/admin-panel/care-managers/filter';
import CareManagersHeader from 'components/organisms/admin-panel/care-managers/header';
import CareManagersTable from 'components/organisms/admin-panel/care-managers/table';
import { Container } from 'reactstrap';

import s from './styles.module.scss';

export const CareManagerPatientsTransferPage = () => {
  return (
    <Container>
      <CareManagersHeader />
      <div className={s.body}>
        <CareManagersFilter />
        <CareManagersTable />
      </div>
      <ScrollToTopButton />
    </Container>
  );
};
